









import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../system/mixins";
import { MenuPane } from "../../../../panes";
import { EditingDocument } from "../..";

@Component({
  components: {
    MenuPane,
  }
})
export default class NoteMenu extends Mixins(ModelEditableMixin) {
  readPropertyOrDefault: <T>(reader: (source: EditingDocument) => T, defaultValue: T) => T;
  writePropertyWhenValid: (writer: (source: EditingDocument) => void) => void;

  get note(): string {
    return this.readPropertyOrDefault(s => s.attributes.note, "");
  }

  async editDocumentNote(): Promise<void> {
    this.$logger.info(this.$wording.document.note + "を編集します。");
    const editedNote = await this.$commonDialogs.document.noteInput.show(true, this.note, true, this.$wording.document.note, "", "文書登録時に保存する");
    if (editedNote !== null) {
      this.writePropertyWhenValid(d => d.attributes.note = editedNote);
      this.writePropertyWhenValid(d => d.attributes.isDocumentNoteEdited = true);
    }
  }
}
